import { FlightSegment, RequireOnly } from '@pelicargo/types';
import { differenceInMinutes } from 'date-fns';

const prettyDuration = ({ hours, minutes }: { hours?: number; minutes?: number }) => {
  if (!hours && !minutes) return '';

  if (minutes === 0) return `${hours}h`;
  if (hours === 0) return `${minutes}m`;

  return `${hours}h ${minutes}m`;
};

export const duration = ({ arrives_at, departs_at }: RequireOnly<FlightSegment, 'arrives_at' | 'departs_at'>) => {
  if (!arrives_at || !departs_at) {
    console.warn('Both arrival and departure times are required');
    return;
  }

  // Arrival has to go before departure
  const durationInMinutes = differenceInMinutes(arrives_at, departs_at);

  const hours = Math.floor(durationInMinutes / 60);
  const minutes = durationInMinutes % 60;

  return { hours, minutes, durationInMinutes, prettyDuration: prettyDuration({ hours, minutes }) };
};
